export default __webpack_public_path__ + "static/checklist-bg-1a5647a1cd748e00c2be3f373bb52ea5.jpg";